import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";

import BIMClasses from "./BIMClasses.graphql";
import { taxonomy } from "../../api";

export default function useBIMClasses() {
    return useQuery(
        gql(BIMClasses),
        {
            client: taxonomy,
        },
    );
}
